<template>
  <div id="page-balance" class="balance">
    <div class="balance-title">
      <van-icon class="balance-title-goback" name="arrow-left" @click="goableBack()" />

      <div class="balance-title-name">
        <span>余额(元)</span>
      </div>
      <div class="balance-title-desc">
        <span>{{ custAccount.balance | numFormat}}</span>
      </div>
    </div>

    <van-row class="balance-links balance-detail">
      <van-col span="8">
        <div class="balance-detail-title">冻结中（元）</div>
        <div class="balance-detail-desc">{{ custAccount.balanceFro | numFormat }}</div>
      </van-col>
      <van-col span="8">
        <div class="balance-detail-title">昨日收益（元）</div>
        <div class="balance-detail-desc">{{ custAccount.incomeY | numFormat }}</div>
      </van-col>
      <van-col span="8">
        <div class="balance-detail-title">累计收益（元）</div>
        <div class="balance-detail-desc">{{ custAccount.incomeAcc | numFormat }}</div>
      </van-col>
    </van-row>
    <van-row class="balance-links balance-control">
      <van-col span="12" @click="onWithdrawDeposit">
        提现
      </van-col>
      <van-col span="12" @click="onRecharge">
        充值
      </van-col>
    </van-row>
    <div style="height: 8px; background-color: #F1F5F8"></div>

    <van-cell-group class="balance-group" v-show="false">
      <van-cell icon="records" title="自动投资" is-link to="/develop" />
    </van-cell-group>
  </div>
</template>

<script>

import { Row, Col, Icon, Cell, CellGroup, Toast, Dialog } from "vant";
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data() {
    return {
      custAccount: {
        balance: '', // 余额
        balanceFro: '', // 冻结余额
        incomeY: '', // 昨日收益
        incomeAcc: '', // 累计收益
      }
    }
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  created() {
    this._showLoading();
    this.getUserInfo().then(data => {
      this._dismissLoading();
      if (!data) {
        Toast("服务器繁忙, 请稍后再试");
        return
      }
      Object.assign(this.custAccount, data.custAccount)
    }).catch(e => {
      this._dismissLoading();
      Toast(e.msg || e.message);
    });
  },

  methods: {
    onWithdrawDeposit() {
      Toast('提现');
    },

    onRecharge() {
      if (this.userInfo.isBindCard) {
        //   this.$router.push({name:'recharge_1'})
        this.$router.push({
          name: "recharge_offline",
          query: { redirect: this.$route.fullPath }
        })
      } else if (this.userInfo.isAuthName) {
        this.$router.push({ name: 'recharge_2' })
      } else {
        this.$router.push({ name: 'recharge_3' })
      }
    },

    ...mapActions([
      'getUserInfo'
    ]),

  }
};
</script>

<style lang="less" scoped>
.balance {
  background-color: #f1f5f8;
  min-height: 100vh;

  &-poster {
    width: 100%;
    height: 53vw;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-title {
    background-image: linear-gradient(
      to right,
      #df4744 0%,
      #df4744 60%,
      #f68e85 100%
    );
    text-align: center;
    padding-top: 80px;
    padding-bottom: 10px;
    position: relative;

    &-name {
      font-size: 18px;
      color: #fff;
    }
    &-desc {
      font-size: 30px;
      color: #fff;
    }
    &-goback {
      font-size: 16px;
      color: #fff;
      height: 46px;
      line-height: 46px;
      position: absolute;
      top: 0;
      left: 0;
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }

  &-detail {
    background-color: #df4845;

    &-title {
      font-size: 10px;
      color: #f58c83;
    }
    &-desc {
      font-size: 14px;
      color: #fff;
      margin-top: 10px;
    }
  }

  &-control {
    .van-col {
      padding-top: 20px;
      padding-bottom: 20px;
      font-size: 20px;
    }

    .van-col:nth-of-type(1) {
      color: #333;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 20%;
        height: 60%;
        width: 1px;
        transform: translateX(0.5);
        background-color: #ccc;
        z-index: 1;
      }
    }
    .van-col:nth-of-type(2) {
      color: #df4845;
    }
  }
}
</style>
